import React from 'react';
import WelcomeScreen from './WelcomeScreen';
import User from '../../models/user-profile/User';
import UserProfileAPI from '../../api/UserProfileAPI';
import moment from 'moment';

export interface IWelcomeScreenContainerProps {
  userId?: string;
  created?: string;
}

export default function WelcomeScreenContainer({ userId = '', created }: IWelcomeScreenContainerProps): JSX.Element {
  const [user, setUser] = React.useState<User>(null);

  React.useEffect(() => {
    if (!user) {
      const api: UserProfileAPI = new UserProfileAPI();
      api.getUserDetails(userId).then(user => setUser(user));
    }
  }, [user, userId]);

  if (user === null) {
    return null;
  } else {
    return <WelcomeScreen user={user} created={moment.utc(created)}></WelcomeScreen>;
  }
}
